import { useEffect, useState } from 'react'
import { Video, EnrichedVideo } from '@/lib/api/client'
import { generateThumbnails } from './functions'

export function useVideoThumbnails(
  videos: Array<Video> = [],
  seekToSeconds: number = 1,
): EnrichedVideo[] {
  const [enrichedVideos, setEnrichedVideos] = useState<EnrichedVideo[]>([])

  useEffect(() => {
    if (!videos?.length) return
    generateThumbnails(videos, seekToSeconds)
      .then((results) => setEnrichedVideos(results))
      .catch(() => {})
  }, [videos, seekToSeconds])

  return enrichedVideos
}
